import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import server from '../../api/server';

import { updateUploadedFiles } from '../../actions';

const ICON_PLUS = (
    <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M10 4a1 1 0 011 1v4h4a1 1 0 110 2h-4v4a1 1 0 11-2 0v-4H5a1 1 0 110-2h4V5a1 1 0 011-1z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_CLOSE = (
    <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M5.3 5.3a1 1 0 011.4 0L10 8.6l3.3-3.3a1 1 0 111.4 1.4L11.4 10l3.3 3.3a1 1 0 01-1.4 1.4L10 11.4l-3.3 3.3a1 1 0 01-1.4-1.4L8.6 10 5.3 6.7a1 1 0 010-1.4z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_FILE = (
    <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M5 2a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8l-6-6H5zm6 0v6h6" />
    </svg>
);

const ICON_CHECK = (
    <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_BANK = (
    <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path d="M10 1 1 5v2h18V5l-9-4zM3 8v7H1v2h18v-2h-2V8h-2v7h-2V8h-2v7H8V8H6v7H4V8H3z" />
    </svg>
);

export class FileUploader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            uploading: false
        };
    }


    uploadImage = async (files) => {
        this.setState({ uploading: true });
        const formData = new FormData();


        console.log(files);
        files.forEach(file => {
            formData.append('files', file);
        });

        formData.append(
            "label",
            this.props.data.label
        );

        formData.append(
            "file_id",
            this.props.data.id
        );

        formData.append(
            "applicant_id",
            this.props.applicant_id
        );

        formData.append(
            "upload_id",
            this.props.document_collection.data.id
        );
        formData.append(
            "application_id",
            this.props.document_collection.data.application_id
        )
        console.log(formData);

        const response = await server.post("/upload", formData).catch(e => { });
        if (response.data && response.data.success == true) {
            this.props.updateUploadedFiles(response.data.fileupload);

        }
        this.setState({ uploading: false });

    };

    deleteFile = async (path, index) => {
        var document_collection = { ...this.props.document_collection.data };
        document_collection.applicants[this.props.applicant_id].requested_documents[this.props.data.id].files.splice(index, 1);
        this.props.updateUploadedFiles(document_collection);
        var response = await server.post("/documentCollection/delete", {
            id: this.props.document_collection.data.id,
            application_id: this.props.params.id,
            path: path,
            index: index,
            file_id: this.props.data.id,
            applicant_id: this.props.applicant_id
        });

    };

    // `min_documents === 0` is how an optional doc type is flagged (there is no
    // separate optional flag). Anything else, including a missing value, needs
    // at least one file.
    minDocuments = () => {
        const min = Number(
            this.props.document_collection.data.applicants[this.props.applicant_id]
                .requested_documents[this.props.data.id].min_documents
        );
        return min > 0 ? min : min === 0 ? 0 : 1;
    };

    isComplete = () => {
        const min = this.minDocuments();
        // Optional types count as complete when empty, so leaving the catch-all
        // "anything else" section blank never holds the upload task open.
        if (min === 0) return true;
        return this.props.data.files.length >= min;
    };

    isOptional = () => this.minDocuments() === 0;

    renderStatusIcon = () => {
        if (this.isComplete()) {
            return (
                <span
                    className="inline-flex items-center justify-center h-7 w-7 rounded-full flex-shrink-0"
                    style={{ backgroundColor: '#DCFCE7', color: '#16A34A' }}
                    aria-label="Complete"
                >
                    {ICON_CHECK}
                </span>
            );
        }
        return (
            <span
                className="inline-flex items-center justify-center h-7 w-7 rounded-full flex-shrink-0 border-2 border-dashed"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#FFFFFF' }}
                aria-label="Not yet uploaded"
            />
        );
    };

    renderFile = (file, index) => (
        <li
            key={`${file.path || file.original_name}-${index}`}
            className="flex items-center gap-2.5 rounded-lg border border-[#E5E7EB] px-2.5 py-1.5 bg-[#F5F6FA]"
        >
            <span style={{ color: '#5B3FE0' }} className="flex-shrink-0">
                {ICON_FILE}
            </span>
            <div className="flex-1 min-w-0">
                <p className="text-xs sm:text-sm font-medium text-[#1F2937] truncate">
                    {file.original_name}
                </p>
            </div>
            <span className="text-[10px] text-[#9CA0AE] flex-shrink-0">
                {(file.size / 1024).toFixed(1)} KB
            </span>
            <button
                type="button"
                onClick={(e) => { e.stopPropagation(); this.deleteFile(file.path, index); }}
                className="inline-flex items-center justify-center h-6 w-6 rounded-md flex-shrink-0 transition-colors hover:bg-white"
                style={{ color: '#9CA0AE' }}
                aria-label="Remove file"
            >
                {ICON_CLOSE}
            </button>
        </li>
    );

    renderURL = () => {
        var URL = 'https://www.bankstatements.com.au/iframe/start/MTGC-PAAS';
        if (this.props.bankstatements.data != undefined) {
            var bankstatements = this.props.bankstatements.data;
            if (bankstatements.applicants[this.props.applicant_id] != undefined) {
                URL = `https://www.bankstatements.com.au/r/b/FTVH-${bankstatements.applicants[this.props.applicant_id].code}`;
            }
        }
        return URL;
    };

    renderBankStatementVariant = () => (
        <section className="rounded-2xl bg-white border border-[#E5E7EB] p-4 sm:p-5">
            <div className="flex items-start gap-3 sm:gap-4">
                <span
                    className="inline-flex items-center justify-center h-9 w-9 rounded-xl flex-shrink-0"
                    style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                >
                    {ICON_BANK}
                </span>
                <div className="flex-1 min-w-0">
                    <h3 className="text-sm sm:text-base font-bold text-[#1F2937] leading-tight">
                        {this.props.data.label}
                    </h3>
                    <p className="mt-1 text-xs sm:text-sm text-[#6B7280] leading-relaxed">
                        Use this secure link to share your statements directly from your
                        bank, built in partnership with the banks for loan applications.
                    </p>
                    <p className="mt-2 text-xs text-[#6B7280] leading-relaxed">
                        Upload any of these accounts that apply to you: salary credit,
                        savings, everyday expenses, credit card facilities, personal loans,
                        and home/investment loan facilities. With multiple institutions,
                        complete the process for each.
                    </p>
                    <a
                        href={this.renderURL()}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="mt-4 inline-flex items-center justify-center rounded-xl px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-transform active:scale-95"
                        style={{ backgroundColor: '#7C5CFC' }}
                    >
                        Collect Bank Statements →
                    </a>
                </div>
            </div>
        </section>
    );

    render() {
        if (this.props.data.label == "Bank Statement Collection") {
            return this.renderBankStatementVariant();
        }

        const files = this.props.data.files || [];
        const fileCount = files.length;
        const optional = this.isOptional();
        const complete = this.isComplete();

        return (
            <Dropzone
                onDrop={(acceptedFiles) => this.uploadImage(acceptedFiles)}
                noClick
            >
                {({ getRootProps, getInputProps, isDragActive, open }) => (
                    <section
                        {...getRootProps()}
                        className="rounded-2xl bg-white border transition-all"
                        style={{
                            borderColor: isDragActive ? '#7C5CFC' : '#E5E7EB',
                            boxShadow: isDragActive ? '0 0 0 3px rgba(124, 92, 252, 0.15)' : 'none',
                            backgroundColor: isDragActive ? '#FAFAFE' : '#FFFFFF',
                        }}
                    >
                        <input {...getInputProps()} />
                        <div className="p-4 sm:p-5">
                            <div className="flex items-start gap-3 sm:gap-4">
                                {this.renderStatusIcon()}

                                <div className="flex-1 min-w-0">
                                    <div className="flex items-start justify-between gap-3 flex-wrap">
                                        <div className="flex-1 min-w-0">
                                            <div className="flex items-center gap-2 flex-wrap">
                                                <h3 className="text-sm sm:text-base font-bold text-[#1F2937] leading-tight">
                                                    {this.props.data.label}
                                                </h3>
                                                {optional ? (
                                                    <span className="text-[10px] uppercase tracking-wide font-semibold" style={{ color: '#9CA0AE' }}>
                                                        Optional
                                                    </span>
                                                ) : null}
                                            </div>
                                            {this.props.data.description ? (
                                                <p className="mt-1 text-xs sm:text-sm text-[#6B7280] leading-relaxed">
                                                    {this.props.data.description}
                                                </p>
                                            ) : null}
                                        </div>

                                        {fileCount > 0 ? (
                                            <span
                                                className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide flex-shrink-0"
                                                style={{
                                                    backgroundColor: complete ? '#DCFCE7' : '#FEF3C7',
                                                    color: complete ? '#15803D' : '#92400E',
                                                }}
                                            >
                                                {fileCount} {fileCount === 1 ? 'file' : 'files'}
                                            </span>
                                        ) : null}
                                    </div>

                                    {fileCount > 0 ? (
                                        <ul className="mt-3 space-y-1.5">
                                            {files.map((f, i) => this.renderFile(f, i))}
                                        </ul>
                                    ) : null}

                                    <div className="mt-3 flex items-center gap-3 flex-wrap">
                                        <button
                                            type="button"
                                            onClick={open}
                                            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs sm:text-sm font-semibold transition-colors"
                                            style={{
                                                backgroundColor: '#EFEAFE',
                                                color: '#5B3FE0',
                                            }}
                                        >
                                            {ICON_PLUS}
                                            {fileCount > 0 ? 'Add another file' : 'Add file'}
                                        </button>

                                        <span className="hidden sm:inline text-[11px] text-[#9CA0AE]">
                                            or drop a file anywhere on this row
                                        </span>

                                        {this.state.uploading == true ? (
                                            <span
                                                className="inline-flex items-center gap-1.5 text-[11px] font-medium ml-auto"
                                                style={{ color: '#5B3FE0' }}
                                            >
                                                <span
                                                    className="inline-block h-3 w-3 rounded-full border-2 border-[#E5E7EB] animate-spin"
                                                    style={{ borderTopColor: '#7C5CFC' }}
                                                />
                                                Uploading…
                                            </span>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </Dropzone>
        );
    }
}

const mapStateToProps = (state) => ({
    document_collection: state.document_collection,
    bankstatements: state.bankstatements
});

const mapDispatchToProps = {
    updateUploadedFiles
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUploader);
